"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = [
    'www.pudelek.pl',
    'www.o2.pl',
    'parenting.pl',
    'zdrowie.parenting.pl',
    'portal.abczdrowie.pl',
    'ranking.abczdrowie.pl',
    'zywienie.abczdrowie.pl',
    'pytania.abczdrowie.pl',
    'koronawirus.abczdrowie.pl',
    'forum.abczdrowie.pl',
    'uroda.abczdrowie.pl',
    'relacje.abczdrowie.pl',
    'open.fm',
    'poczta.wp.pl',
    'poczta.o2.pl',
    'vibez.pl',
    '1login.wp.pl',
    'dev1login.wp.pl',
    'polygamia.pl',
    'gadzetomania.pl',
    'komorkomania.pl',
    'fotoblogia.pl',
    'pysznosci.pl',
    'genialne.pl',
    'autokult.pl',
    'e.autokult.pl',
    'partner.wp.pl',
    'www.dobreprogramy.pl',
    'wirtualnaukraina.pl',
    'vpolshchi.pl',
    'nowosti.pl',
    'www.money.pl',
    'www.autocentrum.pl',
    'essanews.com',
    'dailywrap.uk',
    'canadianwire.ca',
    'wpext.pl',
    'deliciousmagazine.pl',
];
